import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { FieldsErrorText } from '@/components/functional/Form/FieldsErrorText';
import { RfpProOfferPaymentBillingInformationField } from '@/components/modules/pages/rfp/professional/Form/RfpProOfferPaymentBillingInformationFields/RfpProOfferPaymentBillingInformationField';
import { CircleIconButtonWithText } from '@/components/ui/Button/CircleIconButtonWithText';
import { AddIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { SmallTagOutline } from '@/components/ui/Tag/SmallTagOutline';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { getLabelWithOrder } from '@/utils/format/text';
import { draftCheck, validatePaymentBillingInformation, } from '@/utils/validate/resources/rfp/professional/rfpProOffer';
export const RfpProOfferPaymentBillingInformationFields = (props) => {
    const { className = '', fieldKeyNameOfEmail, fieldKeyNameOfFirstName, fieldKeyNameOfLastName, name, orderNumber, tagName: Tag = 'section', } = props;
    const label = useMemo(() => getLabelWithOrder('請求書送付先のご連絡先', orderNumber), [orderNumber]);
    const { fields } = useFieldArray(name, {
        validate: draftCheck(validatePaymentBillingInformation),
    });
    /**
     * Field 追加
     */
    const onClickAddField = useCallback(() => {
        fields.push({
            [fieldKeyNameOfEmail]: '',
            [fieldKeyNameOfFirstName]: '',
            [fieldKeyNameOfLastName]: '',
        });
    }, [
        fields,
        fieldKeyNameOfEmail,
        fieldKeyNameOfFirstName,
        fieldKeyNameOfLastName,
    ]);
    /**
     * Field 削除
     */
    const onClickDeleteField = useCallback((event) => {
        const index = parseInt(event.currentTarget.value, 10);
        if (index > 0) {
            fields.remove(index);
        }
    }, [fields]);
    return (_jsxs(Tag, Object.assign({ className: className }, { children: [_jsxs(Head, Object.assign({ className: clsx('mb-12', 'flex flex-wrap items-center', 'gap-8'), size: 'xs' }, { children: [_jsx("span", { children: label }), _jsx(SmallTagOutline, Object.assign({ className: 'flex-shrink-0', color: 'secondary', isKanjiTopFixed: true }, { children: "\u5FC5\u9808" }))] })), _jsx("ul", { children: fields.map((fieldName, index) => (_jsx(RfpProOfferPaymentBillingInformationField, { className: clsx('pt-20 pl-0 sm:pl-20 pb-20 sm:pb-32', 'border-b border-x-0 border-t-0 border-solid border-gray-100 first:border-t', FIELD_DOM_CLASS_NAME), fieldIndex: index, fieldNameOfEmail: `${fieldName}.${fieldKeyNameOfEmail}`, fieldNameOfFirstName: `${fieldName}.${fieldKeyNameOfFirstName}`, fieldNameOfLastName: `${fieldName}.${fieldKeyNameOfLastName}`, isDeletable: index !== 0, onClickDelete: onClickDeleteField }, fieldName))) }), _jsx(CircleIconButtonWithText, Object.assign({ className: 'mt-20', icon: AddIcon, onClick: onClickAddField, size: 'sm' }, { children: "\u9001\u4ED8\u5148\u3092\u8FFD\u52A0" })), _jsx(FieldsErrorText, { name: name })] })));
};
